import React, {
  createContext,
  MutableRefObject,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from "react";
// import { useLocation, useSearchParams, Location } from "react-router-dom";

type SearchParamsContextType = {
  initialPageLoadSearchParams?: URLSearchParams
  hasNavigatedAwayFromInitialLocation: MutableRefObject<boolean>
};

const InitialLoadContext = createContext<SearchParamsContextType | undefined>(undefined);

export function InitialLoadContextProvider({ children }: any) {

  // const [searchParams] = useSearchParams();
  const [initialPageLoadSearchParams, setInitialPageLoadSearchParams] = useState<URLSearchParams>()

  // const location = useLocation();

  const [initialLocation, setInitialLocation] = useState<Location>()

  const hasNavigatedAwayFromInitialLocation = useRef(false)

  useEffect(() => {
    // setInitialPageLoadSearchParams(searchParams);
    setInitialLocation(location)
  }, []);

  useLayoutEffect(() => {
    if (initialLocation && location.pathname !== initialLocation.pathname) {
      hasNavigatedAwayFromInitialLocation.current = true
    }
  }, [location.pathname]);

  return (
    <InitialLoadContext.Provider
      value={{
        initialPageLoadSearchParams,
        hasNavigatedAwayFromInitialLocation
      }}
    >
      {children}
    </InitialLoadContext.Provider>
  );
}


export function useInitialLoadContext() {
  const context = useContext(InitialLoadContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }

  return context;
}
